import React from "react";
import {Card} from "react-bootstrap";
import {MessagePanelProps} from "../types/props";

const MessagePanel = ({title, symbols, count, message, extra}: MessagePanelProps) => {
  return <Card>
    <Card.Body>
      <Card.Title className="fw-bold">{title}</Card.Title>
      <Card.Text>
        {count === 1 ? <>{symbols} is </> : <>{symbols} are </>}
        {message}
      </Card.Text>
      {extra && <Card.Text>{extra}</Card.Text>}
    </Card.Body>
  </Card>
};

export default MessagePanel;